import http from '@/communication/AuthConnection'

export default async ({ commit }, { eventId }) => {
  const { data } = await http.get(`/v1/result/${eventId}`)
  if (data) {
    commit('SET_LIST', {
      eventItems: data.eventItems
    })
  } else {
    return Promise.reject(Error('Não foi possível carregar a listagem'))
  }
}



// WEBPACK FOOTER //
// ./src/brain/result/load-event/LoadEvent.js